<div #scannerContainer class="scanner-container">
  <div class="zxing_inner">
    <zxing-scanner
      #scanner
      [enable]="scannerEnabled"
      [(device)]="scannerCamera"
      [tryHarder]="true"
      [autofocusEnabled]="false"
      [formats]="scannerFormats"
      (camerasFound)="camerasFoundHandler($event)"
      (scanSuccess)="scanHandler($event)"
      (scanError)="scanErrorHandler($event)"
      (scanFailure)="scanErrorHandler($event)"
      >
    </zxing-scanner>
    @if (!hideZoom) {
      <button
        class="scanner-zoom"
        (click)="_scannerZoomIn = !_scannerZoomIn; setCameraZoom()"
        >
        @if (_scannerZoomIn) {
          <i class="fa-solid fa-magnifying-glass-minus"></i>
        }
        @if (!_scannerZoomIn) {
          <i class="fa-solid fa-magnifying-glass-plus"></i>
        }
      </button>
    }
    @if (scannerEnabled && !scannerResult && !hideSearching) {
      <div
        class="scanner-waiting-result"
        >
        <i class="fas fa-spinner fa-pulse"></i>
        {{ "searching" | translate }}...
      </div>
    }
    @if (scannerResult && !hideScannerResult) {
      <div class="scanner-result">{{ scannerResult }}</div>
    }
  </div>
</div>
